import { render, staticRenderFns } from "./Title_Supplier.vue?vue&type=template&id=16cfdf24&scoped=true&"
import script from "./Title_Supplier.vue?vue&type=script&lang=js&"
export * from "./Title_Supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cfdf24",
  null
  
)

export default component.exports